import React, { ReactNode, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogFooter } from 'src/shared/components/ui/dialog';

import styles from './Confirm.module.scss';
import { PrimaryButton, SecondaryButton } from '../button/Button';

export type ConfirmProps = {
    children: ReactNode;
    title: string;
    content?: ReactNode;
    confirmButtonLabel?: string;
    cancelButtonLabel?: string;
    width?: string;
    onConfirm: () => void;
    onCancel?: () => void;
};

const Confirm = (props: ConfirmProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const { title, content, confirmButtonLabel, cancelButtonLabel, children, width, onConfirm, onCancel } = props;

    const handleCancel = () => {
        setIsOpen(false);
        onCancel?.();
    };

    const handleConfirm = () => {
        setIsOpen(false);
        onConfirm();
    };

    return (
        <>
            <div onClick={() => setIsOpen(true)}>{children}</div>
            {isOpen && (
                <Dialog open={isOpen} onOpenChange={open => !open && onCancel?.()}>
                    <DialogContent style={{ width }} data-testid='confirm-dialog'>
                        <DialogTitle className={styles.title}>{title}</DialogTitle>
                        {content && <div>{content}</div>}
                        <DialogFooter className={styles.actions}>
                            <SecondaryButton onClick={handleCancel}>{cancelButtonLabel || 'Cancel'}</SecondaryButton>
                            <PrimaryButton onClick={handleConfirm}>{confirmButtonLabel || 'Confirm'}</PrimaryButton>
                        </DialogFooter>
                    </DialogContent>
                </Dialog>
            )}
        </>
    );
};

export default Confirm;
